import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'org_unit_name', label: 'Cost Centre' },
  { key: 'account_label', label: 'Account' },
  { key: 'type', label: 'Type' },
  { key: 'budget', label: 'Budget', align: 'right', type: 'money' },
  { key: 'actual', label: 'Actual', align: 'right', type: 'money' },
  { key: 'variance', label: 'Variance', align: 'right', type: 'money' },
  { key: 'variance_percent', label: 'Variance %', align: 'right', type: 'percent' },
];

export function BudgetVarianceReport() {
  return (
    <ReportView
      title="Budget Variance"
      description="Each budget line with its revised budget, actual (completed purchase orders), and variance amount/percent. Defaults to the budget covering today."
      endpoint="/reports/budgets/variance"
      columns={COLUMNS}
      defaultSort="account_label"
      xlsx
    />
  );
}
